const observeAnimations = () => {
    const elements = document.querySelectorAll(".animate-on-scroll");
  
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          } else {
            entry.target.classList.remove("in-view");
          }
        });
      },
      {
        threshold: 0.2, // 20% visible
      }
    );
  
    elements.forEach((el) => observer.observe(el));
  };
  
  export default observeAnimations;
  